import { useValue } from '@morningtrain/react-resources'

export default function ValueAdjustedCircle ({ name, children, defaultValue, className = '' }) {
  let value = useValue(name, defaultValue)

  if (value === 0 && !!defaultValue) {
    value = defaultValue
  }

  const styles = {
    height: (value * 100) + '%',
    width: (value * 100) + '%',
    minHeight: '50px',
    minWidth: '50px'
  }

  return (
    <div className={'bg-white rounded-full border flex justify-center ' + className} style={styles}>
      <div className='flex flex-col justify-center'>
        {children}
      </div>
    </div>
  )
}
